const BANNER_ALLOWED_PAGES = [
  '/home',
  '/meal-plan/step-1',
  '/meal-plan/step-2',
  '/meal-plan/step-3',
  '/meal-plan/step-4',
  '/meal-plan/checkout',
  '/why-we-feed-raw',
  '/our-story',
  '/products',
  '/recipes',
  '/recipes/beef',
  '/recipes/lamb',
  '/recipes/chicken',
  '/recipes/turkey',
  '/recipes/duck',
  '/recipes/venison',
  '/recipes/freeze-dried-raw-beef',
  '/recipes/freeze-dried-raw-chicken',
  '/raw-food-subscription',
  '/raw-benefits',
] as const

const BANNER_CLICK_DISABLED_PAGES = [
  '/meal-plan/step-1',
  '/meal-plan/step-2',
  '/meal-plan/step-3',
  '/meal-plan/step-4',
  '/meal-plan/checkout',
] as const

export const checkIfBannerAllowed = (pathName: string) =>
  pathName.length === 1 || BANNER_ALLOWED_PAGES.some((page) => pathName.includes(page))

export const checkIfClickDisabled = (pathName: string) =>
  BANNER_CLICK_DISABLED_PAGES.some((page) => pathName.includes(page))
